export const linkFractal = (url = '', name = '') => `<a style="color: inherit; text-decoration: underline;" href="${url}" target="_blank">${name}</a>` 

export const messageFractal = (count = 0, type = 'Email', earlyBreak = false) => `${type} is already in use for ${count}${earlyBreak ? "<br/>" : ' '} contact(s):<br/>`
